export const dataFormCertificates = {
  fileName: "",
  productName: "",
  typeFile: null,
};

export const LicenceKeys = {
  key: "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NDYwNTc1OTksImp0aSI6IjgzMjFiN2IxLWM2OGYtNDdiYy1hZTY5LTdjNjM5N2Y1NmE3YiIsInVzYWdlRW5kcG9pbnQiOiJodHRwczovL3Byb3h5LWV2ZW50LmNrZWRpdG9yLmNvbSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsiY2xvdWQiLCJkcnVwYWwiLCJzaCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJsaWNlbnNlVHlwZSI6InRyaWFsIiwiZmVhdHVyZXMiOlsiKiJdLCJ2YyI6IjUyZTcyMjQwIn0.C2DVeJakKHYDdN4xX2_49UxXdiyshszs2MxZxbgtt792TusSLo99Hoq3sqoKw73jQn3Y34Ste0Axlk1Bna9MtA",
};

export const CertificateType = [
  {
    id: "TEMPLATE",
    name: "Template",
  },
  {
    id: "ATTACHMENT",
    name: "Attachment",
  },
  {
    id: "QUICK_PRINT",
    name: "QuickPrint",
  },
];

export const mergeFieldsDataII = [
  {
    definitions: [
      {
        id: "name",
        label: "Nombre",
      },
      {
        id: "birthdate",
        label: "Fecha de nacimiento",
      },
    ],
    groupId: "guest",
    groupLabel: "Informacion del cliente",
  },
  {
    definitions: [
      {
        id: "providerName",
        label: "Provider name",
      },
      {
        id: "providerAddress",
        label: "Provider address",
      },
    ],
    groupId: "InsuranceInfo",
    groupLabel: "Información del seguro",
  },
];

interface Type {
  id: string;
  name: string;
}

export interface DataForm {
  fileName: string;
  productName: string;
  typeFile?: Type | null;
}
